/**
 * @file 表情包列表气泡
 * @author Yangholmes 2023-12-27
 */

import { FC, useEffect, useRef, useState } from 'react';
import cn from 'classnames';

import { IEmoji } from '@/api/common'

import Styles from './emojiPopup.module.scss'

import { useSpringCarousel } from 'react-spring-carousel'

const eNumberPerPage = 18

export interface EmojiPopupProps {
  className?: string;
  emojies: IEmoji[];
  onSelect: (emoji: string) => any;
  onClose: () => any;
}

export const EmojiPopup: FC<EmojiPopupProps> = (props) => {
  const { className, emojies, onSelect, onClose } = props

  const [emojiList, setEmojiList] = useState<IEmoji[][]>([])
  const [currentPage, setCurrentPage] = useState(0)
  const [dragging, setDragging] = useState(false)

  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    let page: IEmoji[] = [];
    let _emojiList: IEmoji[][] = [];
    emojies.forEach((e, i) => {
      page.push(e);
      if ((i % eNumberPerPage === eNumberPerPage - 1) || (i === emojies.length - 1)) {
        _emojiList.push(page);
        page = [];
      }
    })
    setEmojiList(_emojiList);
    let isClickOutside = false
    function handleClickOutside() {
      if (isClickOutside) {
        onClose()
        ref.current?.removeEventListener('click', handleClickInside)
      }
      isClickOutside = true
    }
    function handleClickInside() {
      isClickOutside = false
    }
    document.body.addEventListener('click', handleClickOutside)
    ref.current?.addEventListener('click', handleClickInside)
    return () => {
      document.body.removeEventListener('click', handleClickOutside)
    }
  }, [])

  const { carouselFragment, thumbsFragment, slideToItem, useListenToCustomEvent } = useSpringCarousel({
    initialActiveItem: currentPage,
    withLoop: true,
    withThumbs: true,
    items: emojiList.length > 0 ? emojiList.map((e, i) => ({
      id: `page-${i}`,
      renderThumb: (
        <div
          className={cn(Styles.emojiThumb, currentPage === i ? Styles.active : '')}
          onClick={() => slideToItem(i)}
        />
      ),
      renderItem: (
        <ul className={cn(Styles.emojiList)}>{e.map(emoji => (
          <li className={cn(Styles.container)} key={emoji.code}>
            <div
              className={cn(Styles.emoji, emoji.type === '表情' ? Styles.little : '')}
              style={{
                backgroundImage: `url(${emoji.url})`
              }}
              onMouseUp={() => {
                !dragging && onSelect(emoji.code)
                setDragging(false)
              }}
            />
          </li>
        ))}</ul>
      )
    })) : [{
      id: 'page-X',
      renderThumb: (<></>),
      renderItem: (<div className={cn(Styles.loading)}>loading</div>)
    }],
  })

  useListenToCustomEvent((evt) => {
    if (evt.eventName === 'onDrag') {
      setDragging(true)
    }
    if (evt.eventName === 'onSlideChange') {
      setCurrentPage(evt.currentItem.index)
    }
  })

  return (
    <div ref={ref} className={cn(className, Styles.pcRoot)}>
      <div className={cn(Styles.emojiPicker)}>
        {carouselFragment}
      </div>
      <div className={cn(Styles.emojiThumbs)}>
        {thumbsFragment}
      </div>
    </div>
  )
}

